import { get, post, put } from "../Config";

//POST
export function ImportNurseSlot({ data }) {
  return post({ url: `/api/sb/v1/importNurseSlot`,data});
}
